import { visit } from "unist-util-visit"

export function remarkAdmonition() {
  return (tree) => {
    visit(tree, (node) => {
      if (node.type === "containerDirective") {
        const data = node.data || (node.data = {})
        const type = node.name

        data.hName = "Admonition" // カスタムコンポーネント名
        data.hProperties = {
          type,
          ...(node.attributes || {}),
        }
      }
    })
  }
}
